import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { googleOAuth2 } from "../../actions/authActions";
import { GoogleLogin, GoogleOAuthProvider } from "@react-oauth/google";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import google from "../../g_logo.jpg";
import { blue } from "@material-ui/core/colors";
import { useSnackbar } from "notistack";

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
    backgroundColor: "4285F4",
    width: 450,
    height: 50,
  },
}));

const ColorButton = withStyles((theme) => ({
  root: {
    color: theme.palette.getContrastText(blue[600]),
    backgroundColor: blue[600],
    "&:hover": {
      backgroundColor: blue[800],
    },
  },
}))(Button);

const styles = {
  display: "flex",
  alignItems: "center",
  // justifyContent: 'center',
  flexDirection: "column",
  marginTop: "15%",
};

function Login(props) {
  const [errors, seterrors] = useState({});

  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (props.auth.isAuthenticated) {
      props.history.push("/");
    }
    if (props.errors.emailnotfound && !props.auth.isAuthenticated) {
      enqueueSnackbar(props.errors.emailnotfound, {
        variant: 'error',
      });
      seterrors(props.errors);
    }
    console.log("Errors:", errors)
  }, [props]);
  useEffect(() => {
    seterrors({});
  }, []);

  const classes = useStyles();

  return (
    <div style={styles}>
      <img src="/logo.png" width="220" height="220" alt="logo" />
      <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
        <div style={{ position: 'relative', width: 450, height: 50 }}>
          <ColorButton
            variant="contained"
            className={classes.button}
            style={{ position: 'absolute', top: 0, left: 0, width: '100%', pointerEvents: 'none' }}
            startIcon={
              <Avatar variant="rounded" style={{ marginRight: 20 }} src={google} />
            }
          >
            Log in with Google
          </ColorButton>
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, overflow: 'hidden' }}>
            <GoogleLogin
              onSuccess={props.googleOAuth2}
              onError={props.googleOAuth2}
              width="450"
            />
          </div>
        </div>
      </GoogleOAuthProvider>
    </div>
  );
}

Login.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors,
});

export default connect(mapStateToProps, { googleOAuth2 })(Login);
